import React from "react";
// import { Link } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import MobileMenu from "../components/mobile-menu/MobileMenu";
import MobileBtn from "../components/mobile-menu/MobileBtn";
// import SearchIcon from "../assets/svg/SearchIcon";
import { useMediaQuery } from "react-responsive";
import Logo from "../assets/images/SouthAsiaLogo.png";
// import SearchIconNew from '../assets/images/searchIcon.png'
import { Link, NavLink, useLocation } from "react-router-dom";

const Menu = () => {
  // const triggerSearch = () => {
  //   const offcanvasMobileMenu = document.querySelector(".search_icon_inr");
  //   offcanvasMobileMenu.classList.toggle("active");
  // };
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const location = useLocation();
  const normalizedPath = location.pathname.replace(/\/+$/, "") || "/";

  const matchPath = (paths) => paths.includes(normalizedPath);
  const isServicePath =
    normalizedPath === "/services" || normalizedPath.startsWith("/service/");
  const isProjectPath = normalizedPath === "/projects" || normalizedPath === "/project";
  const isMediaPath = normalizedPath === "/media" || normalizedPath.startsWith("/media/");
  return (
    <>
      {isMobile ? (
        <>
          <div className="menu_area">
            <div className="navigation">
              <div className="container">
                <div className="logo">
                  <Link to="/">
                    <img
                      src={Logo}
                      alt="logo"
                      className="img-fluid Mobile-logo "
                      style={{ width: "48px", height: "49px" }}
                    />
                  </Link>
                </div>
                <p
                  className=" Mobile-Heading primary-color fw500"
                  style={{ fontSize: "16px" }}
                >
                  {" "}
                  South Asia Consultancy{" "}
                </p>

                <MobileBtn />

                <MobileMenu />

                {/* <div className="header_cart">
                  <ul>
                    <li className="header_search">
                      <Link
                        to="#"
                        onClick={() => triggerSearch()}
                        className="cart-toggler search_icon"
                      >
                 
                        <img  src={SearchIconNew} className="img-fluid menu-icon-w" alt='searchIcon'/>
                      </Link>

                      <div className="search_icon_inr">
                        <form action="#" method="POST">
                          <div>
                            <input placeholder="Search" type="text" />
                            <button className="btn-search" type="submit">
                             
                        <img  src={SearchIconNew} className="img-fluid menu-icon-w" alt='searchIcon'/>

                            </button>
                          </div>
                        </form>
                      </div>
                    </li>
                   
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="nav-south-asia  menu-south-asia d-flex align-items-center">
            <div className="container ">
              <div className=" d-flex justify-content-center">
                <Navbar>
                  <Nav className="">
                    <ul className="d-flex sac-main-nav">
                      <li>
                        <NavLink exact to="/" className="menu-text-south" activeClassName="active-link">
                          Home
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/about" className="menu-text-south" activeClassName="active-link">
                          About us{" "}
                        </NavLink>
                      </li>
                      <li className="menu-has-dropdown">
                        <NavLink
                          to="/services"
                          className={`menu-text-south ${isServicePath ? "active-link" : ""}`}
                        >
                          Services
                        </NavLink>
                        <div className="menu-dropdown-panel" role="menu">
                          <Link to="/services#drilling-services" role="menuitem">
                            Drilling Services
                          </Link>
                          <Link to="/services#workover-completion" role="menuitem">
                            Workover &amp; Completion
                          </Link>
                          <Link to="/services#operation-maintenance" role="menuitem">
                            Operation &amp; Maintenance
                          </Link>
                          <Link to="/services#oilfield-equipment" role="menuitem">
                            Oilfield Equipment
                          </Link>
                          <Link to="/services#manpower-supply" role="menuitem">
                            Manpower Supply
                          </Link>
                          <Link to="/services" role="menuitem" className="menu-dropdown-cta">
                            View all services
                          </Link>
                        </div>
                      </li>
                      <li>
                        <NavLink to="/industries" className="menu-text-south" activeClassName="active-link">
                          Industries
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/overseas-recruitment"
                          className="menu-text-south"
                          activeClassName="active-link"
                        >
                          Recruitment{" "}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/projects"
                          className={`menu-text-south ${isProjectPath ? "active-link" : ""}`}
                        >
                          Projects
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/equipment" className="menu-text-south" activeClassName="active-link">
                          Equipment
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/clients" className="menu-text-south" activeClassName="active-link">
                          Clients
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/careers" className="menu-text-south" activeClassName="active-link">
                          Careers
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/media"
                          className={`menu-text-south ${isMediaPath ? "active-link" : ""}`}
                        >
                          Media
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/gallery"
                          className={`menu-text-south ${matchPath(["/gallery", "/gallery-two"]) ? "active-link" : ""}`}
                        >
                          Gallery{" "}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/contact" className="menu-text-south" activeClassName="active-link">
                          Contact
                        </NavLink>
                      </li>
                    </ul>
                  </Nav>
                  {/* <div className="ml-auto">
                    <SearchIcon />
                  </div> */}
                </Navbar>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Menu;
